import React from 'react';
import Link from "next/link";

const Media = ({t}) => {

    const media = t('common:media', {}, {returnObjects: true});

    const MediaItem = ({link}) => {
        return <li className={'media_links_link'}>
            <Link href={link.url}>
                {link.title}
            </Link>
        </li>
    }

    return (
        <section className={'media'}>
            <div className="container">
                <h2 className={'media_title'}>{media.title}</h2>
                <div className="media_wrapper">
                    <p className={'media_description'}>{media.description}</p>
                    <ul className={'media_links'}>
                        {media.links.map((link, i) => {
                            return <MediaItem
                                key={link.title}
                                i={i}
                                link={link}
                            />
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Media;